/** RU is the primary language, UZ is Latin script (AGENTS.md §For frontend work). */
export const SUPPORTED_LANGUAGES = ['ru', 'uz'] as const

export type Language = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: Language = 'ru'

export const LANGUAGE_STORAGE_KEY = 'dorixona.language'

export function isLanguage(value: unknown): value is Language {
  return typeof value === 'string' && SUPPORTED_LANGUAGES.includes(value as Language)
}

/**
 * Picks the first supported language among the candidates, e.g.
 * [stored choice, Telegram `language_code`, navigator.language]. "ru-RU" counts as "ru".
 */
export function resolveLanguage(candidates: readonly (string | null | undefined)[]): Language {
  for (const candidate of candidates) {
    if (!candidate) continue
    const base = candidate.slice(0, 2).toLowerCase()
    if (isLanguage(base)) return base
  }
  return DEFAULT_LANGUAGE
}
